__webpack_require__.p = "/zakelijk/_next/";